import { StateService } from '@uirouter/angular';

import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as _ from 'lodash';

import { UiService } from '../../../../services/core.ui.service';
import { ProjectService } from '../../../../services/project.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { TrackerFilterService } from '../../../../../plugins/tracker/services/tracker.filter.service';
import { ProjectSprintData } from '../../services/project.sprint.data.service';
import { UserService } from '../../../../services/core.user.service';
import { GfTitleService } from '../../../../services/core.title.service';
import { ProjectSprintCutoverComponent } from '../projectSprintCutover/project.sprint.cutover.component';
import { ProjectSprintEditComponent } from '../projectSprintEdit/project.sprint.edit.component';

@Component({
    selector: 'project-sprint-detail',
    template: require('./project.sprint.detail.html'),
})
export class ProjectSprintDetailComponent implements OnInit {

    @Input() project: any = null;
    @Input() projectMenu: any = null;
    @Input() sprint: any = null;

    protected parentCtrl: any = null;

    // Private member variables with default initializers
    protected loading: boolean = false;
    private sprintTitle: string = '';
    protected breadcrumbs: any = null;
    private currentSprintUpdate: any = null;
    private admin: boolean = false;
    protected isSprintAdmin: boolean = false;
    protected summary: any = null;
    private status: string = '';
    private statusLabel: string = '';

    // Wiki Values
    private section: any = null;
    private pageName: string = '';
    /** Starter content for a not-yet-written retrospective; seeded into <wiki-container>. */
    private retroTemplate: string = '';
    /** Gates <wiki-container> render until the retrospective template has settled, so a brand-new
     *  retrospective is seeded with the template rather than the wiki's generic empty state. */
    private retroReady: boolean = false;

    // Charting Values
    private remainingChartOptions: any = null;
    private remainingChartData: any = null;
    private performanceChartOptions: any = null;
    private performanceChartData: any = null;

    // Tracker Item Values
    private trackerItems: any = null;
    private assignees: any[] = [];
    private sort: any = null;
    private tibTrackerDetails: any = null;
    private sortFields: any = null;

    // TIB Options
    private tibOptions: any = {
        allowDownload: false,
        showToolbar: false,
    };

    // Passthrough functions for use by child components
    private getLabelClass: (status: any) => string;
    private getLabelText: (status: any) => string;
    private progressBarColour: (sprint: any) => string;

    protected getActionLabel: (status: any) => string;
    protected getActionClass: (status: any) => string;
    private getTitle: (sprint: any) => string;
    protected getHeading: (sprint: any) => string;

    constructor(
        private projectService: ProjectService,
        private stateService: StateService,
        private uiService: UiService,
        private $window: Window,
        private gfTranslateService: GfTranslateService,
        private trackerFilterService: TrackerFilterService,
        private projectSprintData: ProjectSprintData,
        private userService: UserService,
        private modalService: NgbModal,
        private titleService: GfTitleService,
    ) {
        // Set up passthrough functions for use by child components
        this.getLabelClass = (status) => this.projectSprintData.getSprintLabelClass(status);
        this.getLabelText = (status) => this.projectSprintData.getSprintLabelText(status);
        this.progressBarColour = (sprint) => this.projectSprintData.getProgressBarClass(sprint);

        this.getActionLabel = (status) => this.projectSprintData.getSprintActionLabel(status);
        this.getActionClass = (status) => this.projectSprintData.getSprintActionClass(status);
        this.getTitle = (sprint) => this.projectSprintData.getSprintTitle(sprint);
        this.getHeading = (sprint) => this.projectSprintData.getSprintHeading(sprint);
    }

    ngOnInit() {
        this.parentCtrl = this;

        this.loading = true;
        this.sprintTitle = this.projectSprintData.getSprintTitle(this.sprint);
        this.breadcrumbs = this.projectSprintData.getBreadcrumbs(this.project, this.sprint);

        this.currentSprintUpdate = _.clone(this.sprint);
        this.admin = _.get(this.project, 'rel.permissions.admin', false);
        this.isSprintAdmin = this.admin || _.get(this.project, 'rel.permissions.sprintAdmin', false);

        // Wiki Values
        this.section = this.projectSprintData.getRetrospectiveSection();
        this.pageName = this.projectSprintData.getRetrospectivePageName();

        // Charting Values
        this.remainingChartOptions = this.projectSprintData.getRemainingChartOptions();
        this.performanceChartOptions = this.projectSprintData.getPerformanceChartOptions();

        // Tracker Item Values
        this.trackerItems = null;
        this.assignees = [this.userService.getNobody()];

        this.tibOptions = this.projectSprintData.getTibOptions(this.sprint);
        // BUG - Until we re-write the download feature, disable the button
        this.tibOptions.allowDownload = false;
        this.tibOptions.showToolbar = false;

        this.tibTrackerDetails = this.projectSprintData.getTibTrackerDetails();
        this.sortFields = this.projectSprintData.getTISortFields();
        this.status = '';
        this.statusLabel = 'All';

        this.titleService.setTitle(_.get(this.project, 'name', ''), this.sprintTitle);

        this.refreshAll();

        if (this.sprint.sprintStatus == 2) {
            // The <wiki-container> fetches the retrospective page itself; we only supply the
            // starter template it seeds when no retrospective has been written yet.
            this.projectSprintData.loadRetrospectiveTemplate()
                .then(
                    (template) => { this.retroTemplate = template || ''; this.retroReady = true; },
                    () => { this.retroTemplate = ''; this.retroReady = true; }
                );
        }
    }

    updateCallback = () => {
        this.refreshAll();
    };

    showSprintCutoverModal = () => {
        const modalRef = this.modalService.open(ProjectSprintCutoverComponent);
        modalRef.componentInstance.sprint = this.sprint;
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.refreshAll();
        });
    };

    showSprintEditModal = () => {
        const modalRef = this.modalService.open(ProjectSprintEditComponent);
        modalRef.componentInstance.sprint = this.sprint;
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.refreshAll();
        });
    };

    protected changeStatus = (sprint) => {
        var status;
        switch (sprint.sprintStatus) {
            case 0:
                status = 1;
                break;
            case 1:
                status = 2;
                break;
            case 2:
                status = 0;
                break;
        }
        this.projectService.updateSprint({
            id: this.stateService.params.id,
            project: this.project.id,
            sprintStatus: status
        }).then(
            () => {
                this.uiService.message.showSuccess(this.gfTranslateService.translate('The sprint has been succesfuly updated.'), 'Sprint updated');
                this.getSprintInfo();
            },
            () => {
                var msg = this.gfTranslateService.translate('There was a problem updating the sprint');
                this.uiService.message.showWarning(msg, 'Data Error');
            }
        );
    };

    cancelSprintUpdate = () => {
        this.currentSprintUpdate = _.cloneDeep(this.sprint);
    };

    saveSprint = () => {
        this.currentSprintUpdate.project = this.project.id;
        this.projectService.updateSprint(this.currentSprintUpdate)
            .then(
                () => {
                    this.uiService.message.showSuccess(this.gfTranslateService.translate('The sprint has been succesfuly updated.'), 'Sprint updated');
                    this.sprint = this.currentSprintUpdate;
                    this.breadcrumbs = this.projectSprintData.getBreadcrumbs(this.project, this.sprint);
                },
                () => {
                    var msg = this.gfTranslateService.translate('There was a problem updating the sprint');
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
            );
    };

    getSprintInfo() {
        this.loading = true;

        var rel = (this.sprint.sprintStatus == 2) ?
            'summary,sprintover,burndown,performance' : 'remaining,summary,burndown';

        this.projectService.sprintDetails(
            this.stateService.params.id,
            { rel: rel }
        ).then(
            (response) => {
                this.sprint = response;
                this.summary = this.projectSprintData.getSprintSummaryValues(this.sprint);

                this.currentSprintUpdate = _.cloneDeep(this.sprint);
                this.currentSprintUpdate.totalCount = this.sprint.rel.summary.total_count;
                this.currentSprintUpdate.closedCount = this.sprint.rel.summary.closed_count;

                if (this.sprint.sprintStatus != 2) {
                    this.remainingChartData = this.projectSprintData.getRemainingChartData(this.sprint);
                }

                if (this.sprint.sprintStatus == 2) {
                    this.performanceChartData = this.projectSprintData.getPerformanceChartData(
                        this.sprint,
                        _.get(this.sprint, 'rel.performance', [])
                    );
                }

                this.breadcrumbs = this.projectSprintData.getBreadcrumbs(this.project, this.sprint);

                this.loading = false;
            },
            () => {
                var msg = this.gfTranslateService.translate('There was a problem loading the sprint',
                    {
                        'sprintId': this.stateService.params.id
                    }
                );
                this.uiService.message.showWarning(msg, 'Data Error');
            }
        );
    }

    refreshTIList(params: any = {}) {
        if (_.isEmpty(params)) {
            params = this.stateService.params;
        }

        this.trackerItems = false;

        // Keep the display up to date
        this.sort = this.projectSprintData.getTISort(params, this.sprint);
        this.trackerFilterService.performSearch(
            this.projectSprintData.getTIListArgs(this.project, this.sprint, params)
        ).then(
            (response) => {
                this.trackerItems = response;
            },
            () => {
                this.trackerItems = [];
                var msg = this.gfTranslateService.translate(
                    'There was a problem loading Tracker Items',
                    { 'sprintId':params.id }
                );
                this.uiService.message.showWarning(msg, 'Data Error');
            }
        );
    }

    refreshAll() {
        this.getSprintInfo();
        this.refreshTIList();
    }
}